<template>
	<Navbar>
		<!-- <router-link to="blog"
			class="tracking-tighter">
			{{ $t("header.navigation.blog") }}
		</router-link> -->

		<a :href="$store.state.App.youtube.channel"
			target="_blank"
			alt="Go to Youtube"
			title="Go to Youtube"
			rel="noopener">
			<i class="icon-youtube"
				alt="Youtube icon" />
		</a>

		<Language-Toggle />
	</Navbar>

	<transition name="fade"
		mode="out-in"
		appear>
		<div class="fixed left-0 top-0 bg-black z-30 w-full h-20"
			v-if="scrollY + 100 >= targetY"></div>
	</transition>

	<Hero-Header />

	<section id="HomeContent"
		class="sm:p-10 2xl:p-20 container mx-auto bg-white min-h-screen relative -top-20 shadow-2xl">
		<Personal-Details />

		<Testimonials />

		<Get-In-Touch />
	</section>
</template>

<script>
import Navbar from '@/components/Navigation/Navbar.vue'
import HeroHeader from './HeroHeader.vue'
import PersonalDetails from './PersonalDetails'
import Testimonials from './Testimonials'
import GetInTouch from './GetInTouch'
import LanguageToggle from '@/components/Navigation/LanguageToggle'

export default {
	name: 'Home',

	components: {
		Navbar,
		HeroHeader,
		PersonalDetails,
		Testimonials,
		GetInTouch,
		LanguageToggle,
	},

	data() {
		return {
			scrollY: 0,
			targetY: 200,
		}
	},

	methods: {
		toggleLocale() {
			this.$store.commit('TOGGLE_LOCALE', this.$i18n)
		},

		handleScroll() {
			this.scrollY = window.scrollY
		},
	},

	created() {
		window.addEventListener('scroll', this.handleScroll)
	},

	unmounted() {
		window.removeEventListener('scroll', this.handleScroll)
	},

	mounted() {
		this.targetY = document.getElementById('HomeContent').offsetTop
	},
}
</script>
